import { DateRange } from 'models/date-range'

export interface AnalyticsState {
  readonly dateFrom: DateRange
}

export const analyticsInitialState: AnalyticsState = Object.freeze({
  dateFrom: null,
})
